import { render, staticRenderFns } from "./Bilhetagem.vue?vue&type=template&id=5d613032&"
import script from "./Bilhetagem.vue?vue&type=script&lang=js&"
export * from "./Bilhetagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports